<template>
    <div class="p-3">
        <h2 class="text-uppercase mb-0">
            {{ queueType }}
        </h2>
    </div>
    <Search :url="`/merchant/transport/${queueType}`"  :query="query"/>
    <table class="table table-striped">
        <thead>
        <tr>
            <th>{{ $t('transport.field.fullname') }}</th>
            <th>{{ $t('transport.field.queueType') }}</th>
            <th>{{ $t('transport.field.passenger_number') }}</th>
            <th>{{ $t('transport.field.created_at') }}</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in getList">
            <td>{{ item.firstname }} {{ item.lastname }}</td>
            <td>{{ $t('transport.type.' + item.queueType) }}</td>
            <td>{{ item.passengerNumber }}</td>
            <td>{{ item.created_at }}</td>
            <td class="text-end">
                <button type="button" @click="onOpenModal(item)" class="btn btn-primary">
                    {{ $t('transport.buttons.edit') }}
                </button>
            </td>
        </tr>
        </tbody>
    </table>

    <Pagination v-if="1 !== list.last_page" :links="list.links"/>

    <div ref="editModal" class="modal fade" tabindex="-1" id="editModal" data-bs-backdrop="static" >
        <div class="modal-dialog modal-fullscreen-md-down">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" v-if="selectedElement" id="staticBackdropLabel">
                        {{ selectedElement.firstname }} {{ selectedElement.lastname }}
                    </h1>
                    <button type="button" class="btn-close" @click="onCloseModal()"></button>
                </div>

                <div class="modal-body">
                    <transport-update-form v-if="selectedElement" :item="selectedElement" @updated="onCloseModal" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MerchantLayout from "../../../Layouts/MerchantLayout.vue";
import TransportUpdateForm from "../../../components/Widget/TransportUpdateForm.vue";
import * as Bootstrap from "bootstrap"
import Search from "../../../components/Search.vue";
import Pagination from "../../../components/Pagination.vue";

export default {
    name: "List",
    layout: MerchantLayout,
    props: {
        list: {
            type: Object,
            required: true,
        },
        queueType: {
            type: String
        },
        query: {
            type: String
        }
    },
    data() {
        return {
            selectedElement: null,
            editModal: null
        }
    },
    methods: {
        onOpenModal(item) {
            this.selectedElement = item;
            this.editModal.show();
        },
        onCloseModal() {
            this.editModal.hide();
            this.selectedElement = null;
        }
    },
    computed: {
        getList() {
            return this.list.data
        }
    },
    mounted() {
        this.editModal = new Bootstrap.Modal('#editModal');
    },
    components: {
        Pagination,
        Search,
        TransportUpdateForm
    },
}
</script>

<style scoped>

</style>
